<h4 mat-dialog-title>Valuta il questionario</h4>
<div mat-dialog-content>

  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
    [(ngModel)]="choice">
    <mat-radio-button class="example-radio-button" *ngFor="let choice of data" [value]="choice">
      {{choice}}
    </mat-radio-button>
  </mat-radio-group>
</div>

<div mat-dialog-actions style="justify-content: center">
  <button mat-raised-button color="primary" [mat-dialog-close]="choice">Conferma</button>
  <button mat-raised-button color="warn" (click)="cancel()">Annulla</button>
</div>

